[
  {
    "id": "invoice",
    "label": "Secured Invoice",
    "paymentMethodsID": "3390",
    "translationKey": "payByLink.paymentMethods.securedInvoice"
  },
  {
    "id": "installment",
    "label": "Secured Installment",
    "paymentMethodsID": "3391",
    "translationKey": "payByLink.paymentMethods.securedInstallment"
  },
  {
    "id": "debit",
    "label": "Secured Direct Debit",
    "paymentMethodsID": "3392",
    "translationKey": "payByLink.paymentMethods.securedDirectDebit"
  },
  {
    "id": "creditCard",
    "label": "Credit card",
    "paymentMethodsID": "1,2,3,125,132,5002",
    "translationKey": "payByLink.paymentMethods.creditCard"
  },
  {
    "id": "paypal",
    "label": "Paypal",
    "paymentMethodsID": "840",
    "translationKey": "payByLink.paymentMethods.paypal"
  },
  {
    "id": "wero",
    "label": "WERO",
    "paymentMethodsID": "900",
    "translationKey": "payByLink.paymentMethods.wero"
  },
  {
    "id": "googlePay",
    "label": "Google Pay",
    "paymentMethodsID": "320",
    "translationKey": "payByLink.paymentMethods.googlePay"
  }
]